// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"925309a7","627":"f060337f","653":"56d3b9da","738":"58aa5ba9","923":"2bbafc28"}[chunkId] + ".chunk.js";
};